<div
  class="notification-item d-flex align-items-center gap-2 p-2"
  [class.notification-item--unread]="!notification().read"
  [caLocalizationScope]="localizationScope"
  data-automation-id="ownership-notification-item"
>
  <div class="notification-dot-container d-flex justify-content-center flex-shrink-0">
    @if (!notification().read) {
    <span
      class="notification-unread-dot d-block bg-primary rounded-circle"
      data-automation-id="unread-indicator"
    ></span>
    }
  </div>

  <div class="flex-grow-1 overflow-hidden">
    <div class="d-flex justify-content-between align-items-center">
      <p
        class="body-70 text-truncate mb-1 fw-semibold"
        [title]="notification().title"
        data-automation-id="notification-title"
      >
        {{ notification().title }}
      </p>
      <button
        class="btn btn-link flex-shrink-0 lh-1 p-1 text-muted"
        type="button"
        (click)="onDelete()"
        data-automation-id="delete-notification-btn"
        [title]="'delete' | caLocalize"
      >
        <i class="f-i f-i-close f-i-sm"></i>
      </button>
    </div>

    <div class="text-muted small mb-1" data-automation-id="notification-body" [innerHTML]="notification().body"></div>

    <div class="d-flex justify-content-between align-items-center">
      <span class="text-muted x-small" data-automation-id="notification-date">
        {{ notification().createdAt | date : 'MMM d, y, h:mm a' }}
      </span>
      @if (!notification().read) {
      <button
        class="btn btn-link btn-sm p-0 text-primary small"
        type="button"
        (click)="onMarkAsRead()"
        data-automation-id="mark-read-btn"
      >
        {{ 'markAsRead' | caLocalize }}
      </button>
      }
    </div>
  </div>
</div>
